import React from "react";
import {useStyles} from "../styles/EvenDialogueGenerateSentenceStyle";
import {
    Box,
    Typography,
    Select,
    MenuItem,
    FormControl, TextField, Button
} from "@material-ui/core";
import clsx from "clsx";
import {ReactComponent as ArrowDownIcon} from '../../../../../../common/images/ArrowDownIcon.svg';
import {inject, observer} from "mobx-react";
import {withRouter} from "react-router-dom";

function EvenDialogueRole(props) {
    const classes = useStyles();
    const {evenStepOneStore} = props;
    const {dialogueRoles} = evenStepOneStore;

    const getDefaultRole = (order) => {
        return order === 0 ? 'A' : 'B';
    }
    return (
        <Box className={classes.boxRole}>
            {!!dialogueRoles.length &&
            <Box display={'flex'} alignItems={'center'} justifyContent={'center'} position={'relative'}>
                {dialogueRoles.map((role, i) =>
                    <Box display={'flex'} alignItems={'center'} justifyContent={'center'} key={i} sx={{marginRight: 110}}>
                        <Typography className={classes.typeOption}>{getDefaultRole(i)}</Typography>
                        <Box className={classes.textName}>
                            <TextField id="outlined-basic"
                                       variant="outlined"
                                       placeholder="이름 입력"
                                       onChange={(e) => evenStepOneStore.setSpeakerName(e.target.value, i)}
                                       value={role.speakerName}
                            />
                        </Box>
                        <FormControl className={classes.formControl}>
                            <Select
                                value={role.voiceType}
                                onChange={(e) => evenStepOneStore.setVoiceType(e.target.value, i)}
                                IconComponent={(props) => (
                                    <Box>
                                        <ArrowDownIcon  {...props} />
                                    </Box>
                                )}
                                MenuProps={{
                                    anchorOrigin: {
                                        vertical: "bottom",
                                        horizontal: "right"
                                    },
                                    transformOrigin: {
                                        vertical: 'top',
                                        horizontal: 'right',
                                    },
                                    // getContentAnchorEl: null,
                                    // className:classes.selectPopover
                                }}
                                // onBlur={this.handleDomainBoxFocusOut2}
                            >
                                <MenuItem value='Man'>성인남성</MenuItem>
                                <MenuItem value='Woman'>성인여성</MenuItem>
                                <MenuItem value='Child'>아이</MenuItem>
                                <MenuItem value='Elderly'>노인</MenuItem>
                            </Select>
                        </FormControl>
                    </Box>
                )}
                <Box className={clsx(classes.disabled, classes.buttonStyle)}>
                    <Button disableRipple onClick={evenStepOneStore.setSentenceRoles}>
                        <Typography>역할부여</Typography>
                    </Button>
                </Box>
            </Box>
            }
        </Box>

    );
}

export default withRouter(inject('evenStepOneStore')(observer(EvenDialogueRole)));
